export const LOCAL_DELIVERY_CATEGORIES = new Set([
  "local",
  "next_day",
  "nextDay",
  "same_day",
  "sameDay"
]);

export const DELIVERY_SPEED_LABELS = {
  local: "Faster",
  same_day: "Same Day",
  next_day: "Next Day"
};

export const SHIPPING_METHOD_LABELS = {
  courier: "Courier Delivery",
  standard: "Standard Shipping"
};

export const COURIER_TITLE = "Courier";
